import Link from 'next/link';
import Icon from '@/components/ui/AppIcon';

interface TypedLinkProps {
  title: string;
  url: string;
  type: 'reference' | 'resource' | 'related' | 'external';
  description?: string;
}

const TypedLink = ({ title, url, type, description }: TypedLinkProps) => {
  const typeConfig = {
    reference: {
      icon: 'BookOpenIcon' as const,
      label: 'Reference',
      color: 'text-primary',
      bgColor: 'bg-primary/10',
    },
    resource: {
      icon: 'DocumentTextIcon' as const,
      label: 'Resource',
      color: 'text-accent',
      bgColor: 'bg-accent/10',
    },
    related: {
      icon: 'LinkIcon' as const,
      label: 'Related',
      color: 'text-secondary',
      bgColor: 'bg-secondary/10',
    },
    external: {
      icon: 'ArrowTopRightOnSquareIcon' as const,
      label: 'External',
      color: 'text-muted-foreground',
      bgColor: 'bg-muted',
    },
  };

  const config = typeConfig[type];

  return (
    <Link data-component-id="src/app/project-detail/components/TypedLink.tsx:42:4" data-component-path="src/app/project-detail/components/TypedLink.tsx" data-component-line="42" data-component-end-line="75" data-component-file="TypedLink.tsx" data-component-name="Link" data-component-content="%7B%22elementName%22%3A%22Link%22%2C%22href%22%3A%22%5Bvar%3Aurl%5D%22%2C%22className%22%3A%22group%20flex%20items-start%20space-x-3%20p-4%20rounded-lg%20border%20border-border%20bg-card%20transition-smooth%20hover%3Ashadow-editorial%20hover%3A-translate-y-1%22%7D"
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      className="group flex items-start space-x-3 p-4 rounded-lg border border-border bg-card transition-smooth hover:shadow-editorial hover:-translate-y-1"
    >
      <div data-component-id="src/app/project-detail/components/TypedLink.tsx:48:6" data-component-path="src/app/project-detail/components/TypedLink.tsx" data-component-line="48" data-component-end-line="52" data-component-file="TypedLink.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%7D"
        className={`flex items-center justify-center w-10 h-10 rounded-md ${config.bgColor} flex-shrink-0`}
      >
        <Icon data-component-id="src/app/project-detail/components/TypedLink.tsx:51:8" data-component-path="src/app/project-detail/components/TypedLink.tsx" data-component-line="51" data-component-end-line="51" data-component-file="TypedLink.tsx" data-component-name="Icon" data-component-content="%7B%22elementName%22%3A%22Icon%22%7D" name={config.icon} size={20} className={config.color} />
      </div>

      <div data-component-id="src/app/project-detail/components/TypedLink.tsx:54:6" data-component-path="src/app/project-detail/components/TypedLink.tsx" data-component-line="54" data-component-end-line="68" data-component-file="TypedLink.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex-1%20min-w-0%22%7D" className="flex-1 min-w-0">
        <div data-component-id="src/app/project-detail/components/TypedLink.tsx:55:8" data-component-path="src/app/project-detail/components/TypedLink.tsx" data-component-line="55" data-component-end-line="59" data-component-file="TypedLink.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20items-center%20space-x-2%20mb-1%22%7D" className="flex items-center space-x-2 mb-1">
          <span data-component-id="src/app/project-detail/components/TypedLink.tsx:56:10" data-component-path="src/app/project-detail/components/TypedLink.tsx" data-component-line="56" data-component-end-line="58" data-component-file="TypedLink.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%7D" className={`caption font-medium ${config.color}`}>
            {config.label}
          </span>
        </div>
        <h4 data-component-id="src/app/project-detail/components/TypedLink.tsx:60:8" data-component-path="src/app/project-detail/components/TypedLink.tsx" data-component-line="60" data-component-end-line="62" data-component-file="TypedLink.tsx" data-component-name="h4" data-component-content="%7B%22elementName%22%3A%22h4%22%2C%22className%22%3A%22font-medium%20text-foreground%20group-hover%3Atext-primary%20transition-smooth%20line-clamp-1%22%7D" className="font-medium text-foreground group-hover:text-primary transition-smooth line-clamp-1">
          {title}
        </h4>
        {description && (
          <p data-component-id="src/app/project-detail/components/TypedLink.tsx:64:10" data-component-path="src/app/project-detail/components/TypedLink.tsx" data-component-line="64" data-component-end-line="66" data-component-file="TypedLink.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22caption%20text-muted-foreground%20line-clamp-2%20mt-1%22%7D" className="caption text-muted-foreground line-clamp-2 mt-1">
            {description}
          </p>
        )}
      </div>

      <Icon data-component-id="src/app/project-detail/components/TypedLink.tsx:70:6" data-component-path="src/app/project-detail/components/TypedLink.tsx" data-component-line="70" data-component-end-line="74" data-component-file="TypedLink.tsx" data-component-name="Icon" data-component-content="%7B%22elementName%22%3A%22Icon%22%2C%22name%22%3A%22ArrowTopRightOnSquareIcon%22%2C%22className%22%3A%22text-muted-foreground%20group-hover%3Atext-primary%20transition-smooth%20flex-shrink-0%22%7D"
        name="ArrowTopRightOnSquareIcon"
        size={18}
        className="text-muted-foreground group-hover:text-primary transition-smooth flex-shrink-0"
      />
    </Link>
  );
};

export default TypedLink;